"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValueFromInstance = function (key, encodedInstance) {
    var decodeFunc;
    if (typeof atob !== 'undefined') {
        decodeFunc = atob;
    }
    else {
        decodeFunc = nodeDecoder;
    }
    var echoedData = encodedInstance.split('.').pop();
    var decodedData = decodeFunc(echoedData);
    var instanceObject = JSON.parse(decodedData);
    return instanceObject[key];
};
function nodeDecoder(encodedData) {
    // added "global." to prevent Buffer polyfill in webpack
    return global.Buffer.from(encodedData, 'base64').toString();
}
//# sourceMappingURL=wix-Instance-value.js.map